const sizeChartTops = document.querySelector('[data-size-chart-tops]'); // tops
const sizeChartPanties = document.querySelector('[data-size-chart-panties]'); // panties

const firstContent = document.querySelector('[data-size-guide-first-content]'); // tops
const secondContent = document.querySelector(
  '[data-size-guide-second-content]',
); // panties

const chartButtonsTops = sizeChartTops?.querySelectorAll(
  '[data-size-chart-button]',
) as NodeListOf<Element> | [];
const sizeChartsTops = sizeChartTops?.querySelectorAll('[data-size-chart]') as
  | NodeListOf<Element>
  | [];

const chartButtonsPanties = sizeChartPanties?.querySelectorAll(
  '[data-size-chart-button]',
) as NodeListOf<Element> | [];
const sizeChartsPanties = sizeChartPanties?.querySelectorAll(
  '[data-size-chart]',
) as NodeListOf<Element> | [];

const guidePopupTab = document.querySelectorAll('[data-size-guide-popup-tab]');
const guidePopupContent = document.querySelectorAll(
  '[data-size-guide-popup-content]',
);

const guidePopupViewer = document.querySelectorAll(
  '[data-size-guide-popup-toggler]',
);
const guidePopup = document.querySelector('[data-size-guide-popup]');

const tabToggler = (tabs, containers) => {
  if (!tabs?.length) return;

  tabs.forEach((tab) => {
    tab.addEventListener('click', (event) => {
      event.preventDefault();
      if (tab.classList.contains('active')) return;

      tabs.forEach((tab) => tab.classList.remove('active'));
      tab.classList.add('active');
      containers.forEach((dataSizeChart) =>
        dataSizeChart.classList.toggle('hidden'),
      );
    });
  });
};

const popupViewToggler = (toggleButtons, popup) => {
  if (!toggleButtons.length || !popup) {
    return;
  }

  toggleButtons.forEach((toggleButton) => {
    toggleButton.addEventListener('click', (event) => {
      event.preventDefault();
      popup.classList.toggle('active');

      if (popup.classList.contains('active')) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'unset';
      }
    });
  });
};

const videoPlayerHandler = (container) => {
  if (!container) return;

  const videoPlayButton = container.querySelector(
    '.size-guide-popup__video-play',
  );
  const video = container.querySelector(
    '.size-guide-popup__video video',
  ) as HTMLVideoElement | null;

  if (!video || !videoPlayButton) return;

  videoPlayButton.addEventListener('click', () => {
    if (video.paused) {
      video.play();
      video.classList.remove('hidden');
    } else {
      video.pause();
      video.classList.add('hidden');
    }
  });
};

window.addEventListener('DOMContentLoaded', () => {
  popupViewToggler(guidePopupViewer, guidePopup);
  tabToggler(chartButtonsTops, sizeChartsTops);
  tabToggler(chartButtonsPanties, sizeChartsPanties);
  tabToggler(guidePopupTab, guidePopupContent);
  videoPlayerHandler(firstContent);
  videoPlayerHandler(secondContent);

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape' && guidePopup.classList.contains('active')) {
      guidePopup.classList.remove('active');
      document.body.style.overflow = 'unset';
    }
  });
});
